import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseFormElementComponent } from '../../../../form-elements/base.form.element.component';

@Component({
  selector: 'app-fb-input',
  templateUrl: './fb-input.component.html',
  styleUrls: ['../base.form.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FbInputComponent extends BaseFormElementComponent implements OnChanges, AfterViewInit {
  @Input() public color: string;
  @Input() public fontFamily: string;
  @Input() public inputBackground: string;
  @Input() public fontSize: number;
  @ViewChild('divElement') public container: ElementRef;

  constructor(
    private renderer: Renderer2,
    public translate: TranslateService
  ) {
    super(translate);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (this.container && changes.inputBackground && changes.inputBackground.currentValue) {
      this.setColor();
    }
    super.ngOnChanges(changes);
  }

  public ngAfterViewInit(): void {
    this.setColor();
  }

  private setColor(): void {
    const target: HTMLCollection = this.container.nativeElement.getElementsByClassName('mat-form-field-wrapper');
    target && target[0] && this.renderer.setStyle(target[0], 'background', this.inputBackground || '#fff');
  }

  public get labelStyle(): {[key: string]: string} {
    const fontSize = this.fontSize ? `${+this.fontSize * 0.75}px` : '12px';
    return {
      color: this.color || '#2C3345',
      fontFamily: this.fontFamily || 'Roboto',
      fontSize,
    };
  }

}
